<template>
  <div class="w3-container home">
  
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  export default {
    name: "Home",
    methods:{
    
    },
    data() {
      return {
        msg: ""
      };
    },
    beforeCreated() {},
    created: function() {},
    mounted() {},
    // computed: mapGetters(["seller"]),
    beforeDestroy() {},
    destroy() {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .home {
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue